import SuperagentBase from '../shared/superagent-base';
import appConfig from 'react-global-configuration';

export default class PrimeResource extends SuperagentBase {
    getTransactionContacts(token, transactionId, subscriberId) {
        return new Promise((resolve, reject) => {
            this.request
                .get(
                    `${appConfig.get(
                        'SS_PRIME_API'
                    )}/v1/subscribers/${subscriberId}/transactions/${transactionId}/contacts`
                )
                .set('Authorization', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }
    getListingContacts(token, listingId, subscriberId) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`${appConfig.get('SS_PRIME_API')}/v1/subscribers/${subscriberId}/listings/${listingId}/contacts`)
                .set('Authorization', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/resources/prime-resouce.js